// extracted by mini-css-extract-plugin
module.exports = {"textImageContent":"TextImage_textImageContent__g_yY6"};